import { ValueProvider, InjectionToken } from '@angular/core';
import { environment } from '@env/environment';

export const ENVIRONMENT = new InjectionToken('EnvironmentToken');

export const EnvironmentProvider: ValueProvider = {
  provide: ENVIRONMENT,
  useValue: environment
};
